"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Tile = _interopRequireDefault(require("./Tile.js"));

var _TileState = _interopRequireDefault(require("./TileState.js"));

var _dom = require("./dom.js");

var _Image = require("./Image.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/ImageTile
 */


var ImageTile =
/** @class */
function (_super) {
  __extends(ImageTile, _super);
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [opt_options] Tile options.
   */


  function ImageTile(tileCoord, state, src, crossOrigin, tileLoadFunction, opt_options) {
    var _this = _super.call(this, tileCoord, state, opt_options) || this;
    /**
     * @private
     * @type {?string}
     */


    _this.crossOrigin_ = crossOrigin;
    /**
     * Image URI
     *
     * @private
     * @type {string}
     */

    _this.src_ = src;
    _this.key = src;
    /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */

    _this.image_ = new Image();

    if (crossOrigin !== null) {
      _this.image_.crossOrigin = crossOrigin;
    }
    /**
     * @private
     * @type {?function():void}
     */


    _this.unlisten_ = null;
    /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */

    _this.tileLoadFunction_ = tileLoadFunction;
    return _this;
  }
  /**
   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */


  ImageTile.prototype.getImage = function () {
    return this.image_;
  };
  /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|HTMLImageElement} element Element.
   */


  ImageTile.prototype.setImage = function (element) {
    this.image_ = element;
    this.state = _TileState["default"].LOADED;
    this.unlistenImage_();
    this.changed();
  };
  /**
   * Tracks loading or read errors.
   *
   * @private
   */


  ImageTile.prototype.handleImageError_ = function () {
    this.state = _TileState["default"].ERROR;
    this.unlistenImage_();
    this.image_ = getBlankImage();
    this.changed();
  };
  /**
   * Tracks successful image load.
   *
   * @private
   */


  ImageTile.prototype.handleImageLoad_ = function () {
    var image =
    /** @type {HTMLImageElement} */
    this.image_;

    if (image.naturalWidth && image.naturalHeight) {
      this.state = _TileState["default"].LOADED;
    } else {
      this.state = _TileState["default"].EMPTY;
    }

    this.unlistenImage_();
    this.changed();
  };
  /**
   * Load not yet loaded URI.
   * @api
   */


  ImageTile.prototype.load = function () {
    if (this.state == _TileState["default"].ERROR) {
      this.state = _TileState["default"].IDLE;
      this.image_ = new Image();

      if (this.crossOrigin_ !== null) {
        this.image_.crossOrigin = this.crossOrigin_;
      }
    }

    if (this.state == _TileState["default"].IDLE) {
      this.state = _TileState["default"].LOADING;
      this.changed();
      this.tileLoadFunction_(this, this.src_);
      this.unlisten_ = (0, _Image.listenImage)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
    }
  };
  /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */


  ImageTile.prototype.unlistenImage_ = function () {
    if (this.unlisten_) {
      this.unlisten_();
      this.unlisten_ = null;
    }
  };

  return ImageTile;
}(_Tile["default"]);
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */


function getBlankImage() {
  var ctx = (0, _dom.createCanvasContext2D)(1, 1);
  ctx.fillStyle = 'rgba(0,0,0,0)';
  ctx.fillRect(0, 0, 1, 1);
  return ctx.canvas;
}

var _default = ImageTile;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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